import { Example } from "./Example";

import styles from "./Example.module.css";

interface Props {
    onExampleClicked: (value: string) => void;
    exampleQuestions: string[];
}

export const ExampleList = ({ onExampleClicked, exampleQuestions }: Props) => {
    return (
        <ul className={styles.examplesNavList}>
            {exampleQuestions.map((question, i) => (
                <li key={i}>
                    <Example text={question} value={question} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};
